import React from 'react';
// import { motion } from 'framer-motion';

const TermsAndConditions = () => {
  return (
    <div className="min-h-screen bg-black-900 text-white flex flex-col items-center justify-center p-4">
      <h1 className="text-4xl font-bold mb-4 font-serif">Page Temporarily Disabled</h1>
      <p className="text-lg text-black-300">This page is currently unavailable.</p>
    </div>
  );
  /*
  return (
    <div className="min-h-screen bg-white pt-16">
      <section className="pt-20 pb-16 bg-gradient-to-br from-black-900 to-black-800 text-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl md:text-6xl font-bold text-center">Terms and Conditions</h1>
        </div>
      </section>
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose lg:prose-xl">
            <h2>Agreement to Terms</h2>
            <p>
              By accessing our website and using our services, you agree to be bound by these terms and conditions.
            </p>
            <h2>Intellectual Property</h2>
            <p>
              All content on this website, including courses and materials, is our intellectual property and is protected by copyright laws.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
  */
};

export default TermsAndConditions;